import { RootState } from 'common/store/types'
import { useGetPublicSettingQuery } from 'features/client/services/member'
import { useSelector } from 'react-redux'

const defaultData: any = {
  '': {
    primaryColor: '#00BA8D',
    primaryHoverColor: '#008768',
    primaryFocusColor: '#00664F',
    secondaryColor: '#CCF1E8',
    navigationHoverColor: '#00BA8D',
    loaderColor: '#00BA8D',
  },
}

export const clientPrimaryColors = () => {
  const userData = useSelector(({ user }: RootState) => user)
  const clientName = userData?.clientName || localStorage.getItem('clientName');

  // const { data } = clientName ? useGetColorsQuery('') : defaultData;
  const { data: clientThemeData } = clientName ? useGetPublicSettingQuery(clientName) : defaultData;
  const defaultColourTheme = {
    // primary_brand_colour: '#353A8C',
    // secondary_brand_colour: '#353A8C',
    // top_border_colour: '#ffffff',
    // primary_background_colour: '#EEEEEE',
    // secondary_background_colour: '#E6E6E6',
    // tertiary_background_colour: '#EEEEEE',
    // primary_text: '#0F0F0F',
    // secondary_text: '#757575',
    // primary_link_active: '#353A8C',
    // primary_link_hover: '#0F0F0F',
    // secondary_link_active: '#0F0F0F',
    // secondary_link_hover: '#555555',
    // primary_button_text_active: '#FFFFFF',
    // primary_button_text_hover: '#FFFFFF',
    // primary_button_background_active: '#353A8C',
    // primary_button_background_hover: '#353A8C',
    // primary_button_border_active: '#353A8C',
    // primary_button_border_hover: '#353A8C',
    // secondary_button_text_active: '#353A8C',
    // secondary_button_text_hover: '#353A8C',
    // secondary_button_background_active: '#FFFFFF',
    // secondary_button_background_hover: '#FFFFFF',
    // secondary_button_border_active: '#353A8C',
    // secondary_button_border_hover: '#353A8C',
    primary_brand_colour: '#00BA8D',
    secondary_brand_colour: '#4F5453',
    top_border_colour: '#00BA8D',
    primary_background_colour: '#F5F5F5',
    secondary_background_colour: '#CCF1E8',
    tertiary_background_colour: '#F2FBF9',
    primary_text: '#454545',
    secondary_text: '#727675',
    primary_link_active: '#00BA8D',
    primary_link_hover: '#454545',
    secondary_link_active: '#454545',
    secondary_link_hover: '#00BA8D',
    primary_button_text_active: '#FFFFFF',
    primary_button_text_hover: '#FFFFFF',
    primary_button_background_active: '#00BA8D',
    primary_button_background_hover: '#008768',
    primary_button_border_active: '#00BA8D',
    primary_button_border_hover: '#008768',
    secondary_button_text_active: '#4F5453',
    secondary_button_text_hover: '#008768',
    secondary_button_background_active: '#FFFFFF',
    secondary_button_background_hover: '#FFFFFF',
    secondary_button_border_active: '#4F5453',
    secondary_button_border_hover: '#008768',
    primary_link_sparrow_hover: '#353A8C',
  }

  const colors = clientThemeData ? clientThemeData.colours : defaultColourTheme
  // return { ...defaultColourTheme }
  return { ...colors || { ...defaultColourTheme } }
}
